module.exports = __webpack_public_path__ + "img/fast-delivery-man.972c6dd2.png";